import { render, staticRenderFns } from "./OrdenesProduccionInformacion.vue?vue&type=template&id=21503462&"
import script from "./OrdenesProduccionInformacion.vue?vue&type=script&lang=js&"
export * from "./OrdenesProduccionInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports